import React from 'react';
import image1 from './img/image1.png';
import image2 from './img/image2.png';
import image3 from './img/image3.png';

export default function StepsSection() {
  return (
    <section
      className="flex overflow-hidden flex-col justify-center items-center px-20 py-20 w-full max-md:px-5 max-md:max-w-full"
      style={{
        background: 'rgb(6, 0, 102)',
        backgroundImage: 'linear-gradient(0deg, rgba(6, 0, 102, 1) 0%, rgba(2, 0, 34, 1) 35%)',
      }}>
      <div className="flex flex-col w-full max-w-[1226px] max-md:max-w-full">
        <h2 className="self-center text-5xl font-medium leading-none text-white max-md:max-w-full max-md:text-4xl">
          Steps to Secure the Loan You Need
        </h2>
        <div className="flex flex-wrap gap-10 justify-center items-center mt-14 max-md:mt-10 max-md:max-w-full">
          <img
            loading="lazy"
            src={image1}
            alt="Step 1: Create your request"
            className="object-contain self-stretch my-auto rounded-none aspect-[1.27] min-w-[240px] w-[377px]"
          />
          <img
            loading="lazy"
            src={image2}
            alt="Step 2: Get verified"
            className="object-contain self-stretch my-auto rounded-none aspect-[1.27] min-w-[240px] w-[379px]"
          />
          <img
            loading="lazy"
            src={image3}
            alt="Step 3: Receive funding"
            className="object-contain self-stretch my-auto rounded-none aspect-[1.27] min-w-[240px] w-[379px]"
          />
        </div>
      </div>
    </section>
  );
}